
const ContractForAgreementCtrl = 
        ['$scope', '$filter','Alert', '$routeParams', 'ContractForAgreement', 'AgreementsMaster',
            function ($scope, $filter, Alert, $routeParams, ContractForAgreement, AgreementsMaster) {
                /***********************************************************************************************************
                 * Controller Attributes
                 ***********************************************************************************************************/
                var $translate = $filter('translate');
                var self = this;
                var id = $routeParams.id;

                /***********************************************************************************************************
                 * Scope Attributes
                 ***********************************************************************************************************/


                $scope.ordering = {
                    "is_legal_representative": $translate('CONTRACTS.IS_LEGAL_REPRESENTATIVE')
                };

                $scope.filters = {
                    contract_id: id
                };

                $scope.creationMode = false;
                $scope.errors = {};
                $scope.agreement_manages = false;

                $scope.new = {
                    "contract": id
                }

                /***********************************************************************************************************
                 * Scope Watchers
                 ***********************************************************************************************************/


                /***********************************************************************************************************
                 * Controller Methods
                 ***********************************************************************************************************/

                function resetForm() {
                    $scope.new = {
                        "contract": id
                    }
                }


                /***********************************************************************************************************
                 * Scope Methods
                 ***********************************************************************************************************/

                $scope.toggleCreationMode = function () {
                    $scope.creationMode = !$scope.creationMode;
                };

                $scope.change_agreement_manages = function (value) {
                    $scope.agreement_manages = value;
                };


                $scope.clearError = function() {
                    if ($scope.errors.started_date !== undefined) {
                        delete($scope.errors.started_date);
                    }
                };

                $scope.createContractForAgreement = function () {
                    $scope.errors = {};

                    ContractForAgreement.createContractForAgreement($scope.new).then(function (contract) {
                        $scope.listReload();
                        Alert.createAlert('success', $translate('CONTRACTS.AGREEMENT_ADDED'), true);
                        resetForm();
                        $scope.creationMode = false;
                    }).catch(function (error) {
                        $scope.errors = error;
                    });
                };

                /***********************************************************************************************************
                 * Controller Initialization
                 ***********************************************************************************************************/

                AgreementsMaster.loadAgreements().then(function (response) {
                    $scope.agreements = response;
                });


            }]

export {ContractForAgreementCtrl}
